import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import {
  DT,
  handleServerValidations,
  getDefaultAppTitle,
} from "../../../../../utils/commonfunction";
import { ALLOWED_VIDEO_EXTENSIONS, PHONE_NO_LENGTH, SWAL_SETTINGS } from "../../../../../utils/Constants";
import Loader from "../../../common/loader";
import { URL_REGEX, amountRegex, MOBILE_NUMBER_REGEX } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import { PHONE_VALIDATION } from "../../../../../utils/CommonValidatiobn";
import { Tooltip, Whisper } from "rsuite";
import { useDispatch } from "react-redux";
import { addData } from "../../../../../redux/slices/globalDetails";
import { PhoneInput } from "react-universal-phone";

const TitleSync = ({ title }) => {
  useEffect(() => {
    document.title = getDefaultAppTitle(title);
    const params = new URLSearchParams(window.location.search);
    if (title) {
      params.set("title", title);
    } else {
      params.delete("title");
    }
    const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}`;
    window.history.replaceState(null, "", newUrl);
  }, [title]);

  return null;
};

const GlobalSettings = (props) => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const Dispatch = useDispatch()
  const params = new URLSearchParams(window.location.search);
  const titleParam = params.get("title");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_global_settings"), url: "" },
  ];
  const [refresh, setRefresh] = useState(false);
  const [activeTab, setActiveTab] = useState("global");

  const videoExtensionRegex = new RegExp(
    `(${ALLOWED_VIDEO_EXTENSIONS.map(ext => `\\${ext}`).join('|')})$`,
    'i'
  );

  useEffect(() => {
    globalSettingsService
      .Details()
      .then((response) => {
        setShowDefault(response && response.data ? response?.data : []);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setDataLoaded(true);
      });
  }, [refresh]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const validationSchema = Yup.object().shape({
    AdminEmail: Yup.string()
      .trim()
      .required('label_email_error')
        .matches(emailRegex, t('invalid_email')),

    SupportEmail: Yup.string()
      .trim()
      .required('label_email_error')
        .matches(emailRegex, t('invalid_email')),

    phone_number: PHONE_VALIDATION, // Already handles trimming internally if needed

    CopyRighttxt: Yup.string()
      .trim()
      .required('copyright_error'),

    Address: Yup.string()
      .trim()
      .required('label_location_error')
      .max(100, 'validation_err_reached_maximum_length'),


    title: Yup.string()
      .trim()
      .required('label_title_error')
      .max(50, 'label_title_length_error_50'),

    meta_title: Yup.string()
      .trim()
      .max(100, 'label_title_length_error_100'),

    facebook_link: Yup.string().url(t('invalid_url')),
    instagram_link: Yup.string().url(t('invalid_url')),
    twitter_link: Yup.string().url(t('invalid_url')),
    youtube_link: Yup.string().url(t('invalid_url')),
    linkedin_link: Yup.string().url(t('invalid_url')),
    tiktok_link: Yup.string().url(t('invalid_url')),
    app_store_link: Yup.string().url(t('invalid_url')),
    play_store_link: Yup.string().url(t('invalid_url')),
    android_min_version: Yup.string().trim(),
    android_max_version: Yup.string().trim(),
    ios_min_version: Yup.string().trim(),
    ios_max_version: Yup.string().trim(),
    update_app_text: Yup.string().trim(),
    new_version_text: Yup.string().trim(),

  });
  const getPhoneValue = (phone) => {
    if (!phone || !phone.includes(" ")) {
      return {
        number: "",
        dialCode: "44",
      };
    }

    const [dialCode, number] = phone.split(" ");
    return { dialCode, number };
  };


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          validateOnChange={true}
          enableReinitialize
          initialValues={{
            Address: showdefault && showdefault.address ? showdefault.address : "",

            AdminEmail: showdefault && showdefault.admin_email ? showdefault.admin_email : "",
            SupportEmail: showdefault && showdefault.support_email ? showdefault.support_email : (showdefault && showdefault.admin_email ? showdefault.admin_email : ""),
            phone_number: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
            CopyRighttxt: showdefault && showdefault.copy_right_text ? showdefault.copy_right_text : "",
            default_season: showdefault && showdefault.default_season ? showdefault.default_season : "",
            summary_attachment: showdefault && showdefault.summary_attachment ? showdefault.summary_attachment : "",
            summary_attachment_signed: showdefault && showdefault.summary_attachment_signed ? showdefault.summary_attachment_signed : (showdefault && showdefault.summary_attachment ? showdefault.summary_attachment : ""),
            summary_attachment_file: null,
            title: titleParam !== null ? titleParam : (showdefault && showdefault.title ? showdefault.title : ""),
            logo: showdefault && showdefault.logo ? showdefault.logo : "",
            logo_file: null,
            meta_title: showdefault && showdefault.meta_title ? showdefault.meta_title : "",
            // maintenance_mode: showdefault && showdefault.maintenance_mode ? showdefault.maintenance_mode : false,
            facebook_link: showdefault && showdefault.facebook_link ? showdefault.facebook_link : "",
            instagram_link: showdefault && showdefault.instagram_link ? showdefault.instagram_link : "",
            twitter_link: showdefault && showdefault.twitter_link ? showdefault.twitter_link : "",
            youtube_link: showdefault && showdefault.youtube_link ? showdefault.youtube_link : "",
            linkedin_link: showdefault && showdefault.linkedin_link ? showdefault.linkedin_link : "",
            tiktok_link: showdefault && showdefault.tiktok_link ? showdefault.tiktok_link : "",
            app_store_link: showdefault && showdefault.app_store_link ? showdefault.app_store_link : "",
            play_store_link: showdefault && showdefault.play_store_link ? showdefault.play_store_link : "",
            android_min_version: showdefault && showdefault.android_min_version ? showdefault.android_min_version : "",
            android_max_version: showdefault && showdefault.android_max_version ? showdefault.android_max_version : "",
            ios_min_version: showdefault && showdefault.ios_min_version ? showdefault.ios_min_version : "",
            ios_max_version: showdefault && showdefault.ios_max_version ? showdefault.ios_max_version : "",
            update_app_text: showdefault && (showdefault.update_app_text || showdefault.app_text) ? (showdefault.update_app_text || showdefault.app_text) : "",
            new_version_text: showdefault && showdefault.new_version_text ? showdefault.new_version_text : "",
            standard_fee: showdefault && showdefault.standard_fee !== undefined ? showdefault.standard_fee : 0,
            partner_fee: showdefault && showdefault.partner_fee !== undefined ? showdefault.partner_fee : 0,
            founder_fee: showdefault && showdefault.founder_fee !== undefined ? showdefault.founder_fee : 0,
            platform_fee: showdefault && showdefault.founder_platform_fee_tier1 !== undefined ? showdefault.founder_platform_fee_tier1 : (showdefault && showdefault.platform_fee_tier1 !== undefined ? showdefault.platform_fee_tier1 : (showdefault && showdefault.platform_fee !== undefined ? showdefault.platform_fee : 2.5)),
            platform_fee_tier1: showdefault && showdefault.founder_platform_fee_tier1 !== undefined ? showdefault.founder_platform_fee_tier1 : (showdefault && showdefault.platform_fee_tier1 !== undefined ? showdefault.platform_fee_tier1 : 2.5),
            platform_fee_tier2: showdefault && showdefault.founder_platform_fee_tier2 !== undefined ? showdefault.founder_platform_fee_tier2 : (showdefault && showdefault.platform_fee_tier2 !== undefined ? showdefault.platform_fee_tier2 : 5),
            platform_fee_tier3: showdefault && showdefault.founder_platform_fee_tier3 !== undefined ? showdefault.founder_platform_fee_tier3 : (showdefault && showdefault.platform_fee_tier3 !== undefined ? showdefault.platform_fee_tier3 : 9),
            founder_platform_fee_tier1: showdefault && showdefault.founder_platform_fee_tier1 !== undefined ? showdefault.founder_platform_fee_tier1 : (showdefault && showdefault.platform_fee_tier1 !== undefined ? showdefault.platform_fee_tier1 : 2.5),
            founder_platform_fee_tier2: showdefault && showdefault.founder_platform_fee_tier2 !== undefined ? showdefault.founder_platform_fee_tier2 : (showdefault && showdefault.platform_fee_tier2 !== undefined ? showdefault.platform_fee_tier2 : 5),
            founder_platform_fee_tier3: showdefault && showdefault.founder_platform_fee_tier3 !== undefined ? showdefault.founder_platform_fee_tier3 : (showdefault && showdefault.platform_fee_tier3 !== undefined ? showdefault.platform_fee_tier3 : 9),
            standard_platform_fee_tier1: showdefault && showdefault.standard_platform_fee_tier1 !== undefined ? showdefault.standard_platform_fee_tier1 : 4,
            standard_platform_fee_tier2: showdefault && showdefault.standard_platform_fee_tier2 !== undefined ? showdefault.standard_platform_fee_tier2 : 7.5,
            standard_platform_fee_tier3: showdefault && showdefault.standard_platform_fee_tier3 !== undefined ? showdefault.standard_platform_fee_tier3 : 12.5,
            standard_free_days: showdefault && showdefault.standard_free_days !== undefined ? showdefault.standard_free_days : 30,
            partner_free_days: showdefault && showdefault.partner_free_days !== undefined ? showdefault.partner_free_days : 60,
            founder_free_days: showdefault && showdefault.founder_free_days !== undefined ? showdefault.founder_free_days : 60,
            home_videos: showdefault && showdefault.home_videos ? showdefault.home_videos : [{ url: "", title: "", text: "" }],
            show_faq: showdefault && showdefault.show_faq !== undefined ? showdefault.show_faq : true,
            show_privacy_policy: showdefault && showdefault.show_privacy_policy !== undefined ? showdefault.show_privacy_policy : true,
            show_terms_condition: showdefault && showdefault.show_terms_condition !== undefined ? showdefault.show_terms_condition : true,
            show_rules_of_the_games: showdefault && showdefault.show_rules_of_the_games !== undefined ? showdefault.show_rules_of_the_games : true,
            show_safeguard_policy: showdefault && showdefault.show_safeguard_policy !== undefined ? showdefault.show_safeguard_policy : true,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);

            // Trimmed version of all fields
            const trimmedValues = {
              Address: values.Address.trim(),
              AdminEmail: values.AdminEmail.trim(),
              SupportEmail: values.SupportEmail.trim(),
              phone_number: values.phone_number.trim(),
              CopyRighttxt: values.CopyRighttxt.trim(),
              default_season: values.default_season ? values.default_season.trim() : "",
              title: values.title.trim(),
            };

            let formData = new FormData();
            formData.append("address", trimmedValues.Address);
            formData.append("admin_email", trimmedValues.AdminEmail);
            formData.append("support_email", trimmedValues.SupportEmail);
            formData.append("phone_number", trimmedValues.phone_number);
            formData.append("copy_right_text", trimmedValues.CopyRighttxt);
            formData.append("default_season", trimmedValues.default_season);
            formData.append("summary_attachment", values.summary_attachment || "");
            if (values.summary_attachment_file) {
              formData.append("summary_attachment_file", values.summary_attachment_file);
            }
            formData.append("title", trimmedValues.title);
            formData.append("meta_title", values.meta_title);
            // formData.append("maintenance_mode", values.maintenance_mode);
            formData.append("facebook_link", values.facebook_link);
            formData.append("instagram_link", values.instagram_link);
            formData.append("twitter_link", values.twitter_link);
            formData.append("youtube_link", values.youtube_link);
            formData.append("linkedin_link", values.linkedin_link);
            formData.append("tiktok_link", values.tiktok_link);
            formData.append("app_store_link", values.app_store_link || "");
            formData.append("play_store_link", values.play_store_link || "");
            formData.append("android_min_version", values.android_min_version ? values.android_min_version.trim() : "");
            formData.append("android_max_version", values.android_max_version ? values.android_max_version.trim() : "");
            formData.append("ios_min_version", values.ios_min_version ? values.ios_min_version.trim() : "");
            formData.append("ios_max_version", values.ios_max_version ? values.ios_max_version.trim() : "");
            formData.append("update_app_text", values.update_app_text ? values.update_app_text.trim() : "");
            formData.append("app_text", values.update_app_text ? values.update_app_text.trim() : "");
            formData.append("new_version_text", values.new_version_text ? values.new_version_text.trim() : "");
            formData.append("standard_fee", values.standard_fee);
            formData.append("partner_fee", values.partner_fee);
            formData.append("founder_fee", values.founder_fee);
            formData.append("platform_fee", values.founder_platform_fee_tier1 !== undefined ? values.founder_platform_fee_tier1 : values.platform_fee_tier1);
            formData.append("platform_fee_tier1", values.founder_platform_fee_tier1 !== undefined ? values.founder_platform_fee_tier1 : values.platform_fee_tier1);
            formData.append("platform_fee_tier2", values.founder_platform_fee_tier2 !== undefined ? values.founder_platform_fee_tier2 : values.platform_fee_tier2);
            formData.append("platform_fee_tier3", values.founder_platform_fee_tier3 !== undefined ? values.founder_platform_fee_tier3 : values.platform_fee_tier3);
            formData.append("founder_platform_fee_tier1", values.founder_platform_fee_tier1);
            formData.append("founder_platform_fee_tier2", values.founder_platform_fee_tier2);
            formData.append("founder_platform_fee_tier3", values.founder_platform_fee_tier3);
            formData.append("standard_platform_fee_tier1", values.standard_platform_fee_tier1);
            formData.append("standard_platform_fee_tier2", values.standard_platform_fee_tier2);
            formData.append("standard_platform_fee_tier3", values.standard_platform_fee_tier3);
            formData.append("standard_free_days", values.standard_free_days);
            formData.append("partner_free_days", values.partner_free_days);
            formData.append("founder_free_days", values.founder_free_days);
            formData.append("show_faq", values.show_faq);
            formData.append("show_privacy_policy", values.show_privacy_policy);
            formData.append("show_terms_condition", values.show_terms_condition);
            formData.append("show_rules_of_the_games", values.show_rules_of_the_games);
            formData.append("show_safeguard_policy", values.show_safeguard_policy);
            formData.append("logo", values.logo);
            if (values.logo_file) {
              formData.append("logo_file", values.logo_file);
            }
            
            // Clean up home_videos for metadata submission (exclude File objects)
            const videoMetadata = values.home_videos.map(v => ({
              type: v.type || 'video',
              url: v.url,
              icon: v.icon,
              title: v.title,
              text: v.text
            }));
            formData.append("home_videos", JSON.stringify(videoMetadata));

            // Append files separately with unique keys
            values.home_videos.forEach((vid, i) => {
              if (vid.file) {
                formData.append(`home_video_file_${i}`, vid.file);
              }
              if (vid.icon_file) {
                formData.append(`home_icon_file_${i}`, vid.icon_file);
              }
            });

            console.log("formData--->1", formData)
            globalSettingsService
              .Add(formData)
              .then((response) => {
                if (response.success) {
                  Dispatch(addData(response.data));
                  setRefresh((prev) => !prev);
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    setSubmitted(false);
                  }, 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting, setFieldTouched }) => (
            <form onSubmit={handleSubmit}>
              <TitleSync title={values.title} />
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("sidebar_link_global_settings")}</h6>
                      </div>

                      <ul className="nav nav-tabs mb-4">
                        <li className="nav-item">
                          <button className={`nav-link ${activeTab === "global" ? "active fw-bold" : ""}`} type="button" onClick={() => setActiveTab("global")}>Global Settings</button>
                        </li>
                        <li className="nav-item">
                          <button className={`nav-link ${activeTab === "payment" ? "active fw-bold" : ""}`} type="button" onClick={() => setActiveTab("payment")}>Payment Settings</button>
                        </li>
                        <li className="nav-item">
                          <button className={`nav-link ${activeTab === "app_tabs" ? "active fw-bold" : ""}`} type="button" onClick={() => setActiveTab("app_tabs")}>App Info Tabs</button>
                        </li>
                      </ul>

                      {activeTab === "global" && (
                        <>
                          <div className="row row-sm">
                            <div className="col-md-6 text-center form-group">
                              <label htmlFor="title" className="text-left d-flex">
                            {t("title")}:<span className="requirestar">*</span>{" "}
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip style={{ fontWeight: "bold" }}>This title will be show as marketing website title </Tooltip>}
                            >
                              <span className="field-more-info  ms-1 cp" aria-describedby="control-id-hover">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input name="title" type="text" id="title" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" placeholder={t("Enter title")} />
                          <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                        </div>

                        {/* <div className="col-md-6 text-center form-group">
                          <label htmlFor="logo" className="text-left d-flex">
                            Logo:
                          </label>
                          <div className="d-flex align-items-center gap-3">
                            {values.logo && (
                              <div className="border rounded p-1 bg-white" style={{ height: "40px", width: "40px" }}>
                                <img 
                                  src={values.logo.startsWith("blob:") ? values.logo : values.logo} 
                                  alt="Logo Preview" 
                                  style={{ height: "100%", width: "100%", objectFit: "contain" }} 
                                />
                              </div>
                            )}
                            <div className="flex-grow-1">
                              <input
                                type="file"
                                id="logo_file"
                                className="form-control"
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  if (file) {
                                    setFieldValue("logo_file", file);
                                    setFieldValue("logo", URL.createObjectURL(file));
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <span className="text-danger d-flex text-left">{errors.logo_file && touched.logo_file && t(errors.logo_file)}</span>
                        </div> */}

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="CopyRighttxt" className="text-left d-flex">
                            {t("label_copy_right_text")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="CopyRighttxt"
                            type="text"
                            id="CopyRighttxt"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.CopyRighttxt}
                            className="form-control"
                            placeholder={t("Enter copy right text")}
                          />
                          <span className="text-danger d-flex text-left">{errors.CopyRighttxt && touched.CopyRighttxt && t(errors.CopyRighttxt)}</span>
                        </div>
                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="SupportEmail" className="text-left d-flex">
                            {t("label_support")} {t("label_email")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="SupportEmail"
                            type="text"
                            id="SupportEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.SupportEmail}
                            className="form-control"
                            placeholder={t("placeholder_email_address")}
                          />
                          <span className="text-danger d-flex text-left">{errors.SupportEmail && touched.SupportEmail && t(errors.SupportEmail)}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="AdminEmail" className="text-left d-flex">
                            Admin Email:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="AdminEmail"
                            type="text"
                            id="AdminEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.AdminEmail}
                            className="form-control"
                            placeholder={t("placeholder_email_address")}
                          />
                          <span className="text-danger d-flex text-left">{errors.AdminEmail && touched.AdminEmail && t(errors.AdminEmail)}</span>
                        </div>

                        {/* <div className="col-md-6 form-group phone-input-wrapper">
                          <label htmlFor="phone_number" className="text-left d-flex">
                            {t("label_support")} {t("label_contact_no")}:
                            <span className="requirestar">*</span>
                          </label>

                          <PhoneInput
                            id="phone_number"
                            defaultCountry="GB"
                            locale="en"
                            label={false}
                            value={getPhoneValue(values.phone_number)}
                            onBlur={() => setFieldTouched("phone_number", true)}
                            onChange={(data) => {
                              setFieldValue(
                                "phone_number",
                                data?.formattedPhoneNumber || ""
                              );
                            }}
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.phone_number &&
                              touched.phone_number &&
                              DT(
                                t(errors.phone_number),
                                {
                                  PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min,
                                  PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max,
                                }
                              )}
                          </span>
                        </div> */}

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="default_season" className="text-left d-flex">
                            Default Season:
                          </label>
                          <input
                            name="default_season"
                            type="date"
                            id="default_season"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.default_season}
                            className="form-control"
                            placeholder="Enter default season"
                          />
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="summary_attachment_file" className="text-left d-flex align-items-center justify-content-between">
                            <span>Summary Attachment:</span>
                            {(values.summary_attachment_signed || values.summary_attachment) && typeof (values.summary_attachment_signed || values.summary_attachment) === "string" && (values.summary_attachment_signed || values.summary_attachment).startsWith("http") ? (
                              <a
                                href={values.summary_attachment_signed || values.summary_attachment}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="badge bg-primary text-white text-decoration-none py-1 px-2"
                                style={{ fontSize: "12px" }}
                              >
                                <i className="fa fa-eye me-1"></i> View Current Attachment
                              </a>
                            ) : null}
                          </label>
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="file"
                              id="summary_attachment_file"
                              name="summary_attachment_file"
                              className="form-control"
                              accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                if (file) {
                                  setFieldValue("summary_attachment_file", file);
                                  setFieldValue("summary_attachment", file.name);
                                }
                              }}
                            />
                            {(values.summary_attachment || values.summary_attachment_file) && (
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                title="Remove Attachment"
                                onClick={() => {
                                  setFieldValue("summary_attachment_file", null);
                                  setFieldValue("summary_attachment", "");
                                  setFieldValue("summary_attachment_signed", "");
                                  const fileInput = document.getElementById("summary_attachment_file");
                                  if (fileInput) fileInput.value = "";
                                }}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            )}
                          </div>
                          {values.summary_attachment && (
                            <small className="text-muted d-block mt-1 text-start">
                              {values.summary_attachment_file ? `Selected: ${values.summary_attachment}` : `Current file: ${values.summary_attachment.split("/").pop()}`}
                            </small>
                          )}
                        </div>

               

                        {/* <div className="col-md-12 text-center form-group">
                          <label htmlFor="Address" className="text-left d-flex">
                            {t("label_support")} {t("list_heading_address")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="Address"
                            id="Address"
                            type="text"
                            style={{ minHeight: "100px" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.Address}
                            className="form-control"
                            placeholder={t("placeholder_address")}
                          />
                          <span className="text-danger d-flex text-left">{errors.Address && touched.Address && t(errors.Address)}</span>
                        </div> */}

                   

                        <div className="col-md-12 form-group">
                          <label htmlFor="meta_title" className="text-left d-flex">
                            Footer Title:
                          </label>
                          <input
                            name="meta_title"
                            type="text"
                            id="meta_title"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_title}
                            className="form-control"
                            placeholder="Enter banner meta title"
                          />
                          <span className="text-danger d-flex text-left">{errors.meta_title && touched.meta_title && t(errors.meta_title)}</span>
                        </div>

                        <div className="col-md-12">
                          <hr />
                          <h6 className="main-content-label mb-3">Social Media Links</h6>
                        </div>

                        {[
                          { name: 'facebook_link', label: 'Facebook Link' },
                          { name: 'instagram_link', label: 'Instagram Link' },
                          // { name: 'twitter_link', label: 'Twitter Link' },
                          // { name: 'youtube_link', label: 'YouTube Link' },
                          // { name: 'linkedin_link', label: 'LinkedIn Link' },
                          { name: 'tiktok_link', label: 'TikTok Link' },
                        ].map((field) => (
                          <div className="col-md-6 form-group" key={field.name}>
                            <label htmlFor={field.name} className="text-left d-flex">
                              {field.label}:
                            </label>
                            <input
                              name={field.name}
                              type="text"
                              id={field.name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values[field.name]}
                              className="form-control"
                              placeholder={`Enter ${field.label.toLowerCase()}`}
                            />
                            <span className="text-danger d-flex text-left">{errors[field.name] && touched[field.name] && t(errors[field.name])}</span>
                          </div>
                        ))}

                        <div className="col-md-12">
                          <hr />
                          <h6 className="main-content-label mb-3">App Store Links</h6>
                        </div>

                        {[
                          { name: 'app_store_link', label: 'Apple Store Link' },
                          { name: 'play_store_link', label: 'Play Store Link' },
                        ].map((field) => (
                          <div className="col-md-6 form-group" key={field.name}>
                            <label htmlFor={field.name} className="text-left d-flex">
                              {field.label}:
                            </label>
                            <input
                              name={field.name}
                              type="text"
                              id={field.name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values[field.name]}
                              className="form-control"
                              placeholder={`Enter ${field.label.toLowerCase()}`}
                            />
                            <span className="text-danger d-flex text-left">{errors[field.name] && touched[field.name] && t(errors[field.name])}</span>
                          </div>
                        ))}

                        <div className="col-md-12">
                          <hr />
                          <h6 className="main-content-label mb-3">App Version Settings</h6>
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="android_min_version" className="text-left d-flex">
                            Android Min Version:
                          </label>
                          <input
                            name="android_min_version"
                            type="text"
                            id="android_min_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.android_min_version}
                            className="form-control"
                            placeholder="Enter Android min app version (e.g. 1.0.0)"
                          />
                          <span className="text-danger d-flex text-left">{errors.android_min_version && touched.android_min_version && t(errors.android_min_version)}</span>
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="android_max_version" className="text-left d-flex">
                            Android Max Version:
                          </label>
                          <input
                            name="android_max_version"
                            type="text"
                            id="android_max_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.android_max_version}
                            className="form-control"
                            placeholder="Enter Android max app version (e.g. 2.0.0)"
                          />
                          <span className="text-danger d-flex text-left">{errors.android_max_version && touched.android_max_version && t(errors.android_max_version)}</span>
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="ios_min_version" className="text-left d-flex">
                            iOS Min Version:
                          </label>
                          <input
                            name="ios_min_version"
                            type="text"
                            id="ios_min_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.ios_min_version}
                            className="form-control"
                            placeholder="Enter iOS min app version (e.g. 1.0.0)"
                          />
                          <span className="text-danger d-flex text-left">{errors.ios_min_version && touched.ios_min_version && t(errors.ios_min_version)}</span>
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="ios_max_version" className="text-left d-flex">
                            iOS Max Version:
                          </label>
                          <input
                            name="ios_max_version"
                            type="text"
                            id="ios_max_version"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.ios_max_version}
                            className="form-control"
                            placeholder="Enter iOS max app version (e.g. 2.0.0)"
                          />
                          <span className="text-danger d-flex text-left">{errors.ios_max_version && touched.ios_max_version && t(errors.ios_max_version)}</span>
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="update_app_text" className="text-left d-flex">
                            Update App Text:
                          </label>
                          <textarea
                            name="update_app_text"
                            id="update_app_text"
                            rows={3}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.update_app_text}
                            className="form-control"
                            placeholder="Enter update app text"
                          />
                          <span className="text-danger d-flex text-left">{errors.update_app_text && touched.update_app_text && t(errors.update_app_text)}</span>
                        </div>

                        <div className="col-md-6 form-group">
                          <label htmlFor="new_version_text" className="text-left d-flex">
                            New Version Text:
                          </label>
                          <textarea
                            name="new_version_text"
                            id="new_version_text"
                            rows={3}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.new_version_text}
                            className="form-control"
                            placeholder="Enter new version text"
                          />
                          <span className="text-danger d-flex text-left">{errors.new_version_text && touched.new_version_text && t(errors.new_version_text)}</span>
                        </div>

                        <div className="col-md-12">
                          <hr />
                          <h6 className="main-content-label mb-3">Home Page Videos</h6>
                        </div>

                        <FieldArray
                          name="home_videos"
                          render={(arrayHelper) => (
                            <div className="col-12 mb-4">
                              <div className="row">
                                {values?.home_videos && values?.home_videos?.length >= 0 ? (
                                  values?.home_videos.map((item, index) => (
                                    <div className="col-12 mb-2" key={index}>
                                      <div className="w-100 p-3 bg-light border rounded">
                                        <div className="row">
                                          <div className="col-md-2 form-group mb-0">
                                            <label className="text-left d-flex small fw-bold">Type:</label>
                                            <select
                                              className="form-control"
                                              name={`home_videos[${index}].type`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.type || 'video'}
                                            >
                                              <option value="video">Video</option>
                                              <option value="image">Image</option>
                                            </select>
                                          </div>
                                          <div className="col-md-3 form-group mb-0">
                                            <label className="text-left d-flex small fw-bold">Media File / URL:</label>
                                            <div className="d-flex gap-2">
                                              <input
                                                className="form-control"
                                                name={`home_videos[${index}].url`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={item.url}
                                                placeholder="Media URL or select file"
                                              />
                                              <div className="position-relative">
                                                <button type="button" className="btn btn-sm btn-outline-primary h-100" onClick={() => document.getElementById(`media-file-${index}`).click()}>
                                                  Upload
                                                </button>
                                                <input
                                                  type="file"
                                                  id={`media-file-${index}`}
                                                  className="d-none"
                                                  accept={item.type === 'image' ? 'image/*' : 'video/*'}
                                                  onChange={(e) => {
                                                    const file = e.currentTarget.files[0];
                                                    if (file) {
                                                      setFieldValue(`home_videos[${index}].file`, file);
                                                      setFieldValue(`home_videos[${index}].url`, file.name); // Show filename
                                                    }
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            {item.url && item.url.startsWith('http') && (
                                              <div className="mt-1">
                                                <a href={item.url} target="_blank" rel="noreferrer" className="small text-primary">Preview media</a>
                                              </div>
                                            )}
                                          </div>
                                          <div className="col-md-3 form-group mb-0">
                                            <label className="text-left d-flex small fw-bold">Icon File / URL:</label>
                                            <div className="d-flex gap-2">
                                              <input
                                                className="form-control"
                                                name={`home_videos[${index}].icon`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={item.icon}
                                                placeholder="Icon URL or upload"
                                              />
                                              <div className="position-relative">
                                                <button type="button" className="btn btn-sm btn-outline-secondary h-100" onClick={() => document.getElementById(`icon-file-${index}`).click()}>
                                                  Icon
                                                </button>
                                                <input
                                                  type="file"
                                                  id={`icon-file-${index}`}
                                                  className="d-none"
                                                  accept="image/*"
                                                  onChange={(e) => {
                                                    const file = e.currentTarget.files[0];
                                                    if (file) {
                                                      setFieldValue(`home_videos[${index}].icon_file`, file);
                                                      setFieldValue(`home_videos[${index}].icon`, file.name);
                                                    }
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            {item.icon && item.icon.startsWith('http') && (
                                              <div className="mt-1">
                                                <img src={item.icon} alt="Icon preview" style={{height: '20px', width: '20px', objectFit: 'contain'}} />
                                              </div>
                                            )}
                                          </div>
                                          <div className="col-md-2 form-group mb-0">
                                            <label className="text-left d-flex small fw-bold">Title:</label>
                                            <input
                                              className="form-control"
                                              name={`home_videos[${index}].title`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.title}
                                              placeholder="Enter display title"
                                            />
                                          </div>
                                          <div className="col-md-2 form-group mb-0">
                                            <label className="text-left d-flex small fw-bold">Description:</label>
                                            <input
                                              className="form-control"
                                              name={`home_videos[${index}].text`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.text}
                                              placeholder="Short text"
                                            />
                                          </div>
                                          <div className="col-md-12 d-flex align-items-end justify-content-end mt-2">
                                            <div className="social-media-action">
                                              <button
                                                className="btn btn-danger btn-sm"
                                                type="button"
                                                disabled={values?.home_videos?.length === 1}
                                                onClick={() => arrayHelper.remove(index)}
                                              >
                                                Remove
                                              </button>
                                              {index === values?.home_videos?.length - 1 && (
                                                <button
                                                  className="btn btn-main-primary btn-sm ms-2"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelper.insert(values?.home_videos?.length, {
                                                      type: "video",
                                                      url: "",
                                                      icon: "",
                                                      title: "",
                                                      text: "",
                                                    })
                                                  }
                                                >
                                                  Add
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <button className="btn btn-main-primary signbtn mr-2 ms-2 mb-3" type="button" onClick={() => arrayHelper.push({ url: "", title: "", text: "" })}>
                                    Add a video
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        />
                          </div>
                        </>
                      )}

                      {activeTab === "payment" && (
                        <>
                          <div className="row row-sm">
                            <div className="col-md-4 form-group">
                              <label htmlFor="standard_fee" className="text-left d-flex">Standard Club Fee (GBP per player):</label>
                              <input
                                name="standard_fee"
                                type="number"
                                id="standard_fee"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.standard_fee}
                                className="form-control"
                                placeholder="Enter standard fee"
                              />
                            </div>
                           
                            <div className="col-md-4 form-group">
                              <label htmlFor="founder_fee" className="text-left d-flex">Founding Partner Club Fee(GBP per player):</label>
                              <input
                                name="founder_fee"
                                type="number"
                                id="founder_fee"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.founder_fee}
                                className="form-control"
                                placeholder="Enter founder fee"
                              />
                            </div>
                          </div>
                          <div className="row row-sm mt-3">
                            <div className="col-md-4 form-group">
                              <label htmlFor="standard_free_days" className="text-left d-flex">Standard Club Trial Days:</label>
                              <input
                                name="standard_free_days"
                                type="number"
                                id="standard_free_days"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.standard_free_days}
                                className="form-control"
                                placeholder="Enter standard free trial days"
                              />
                            </div>
                          
                            <div className="col-md-4 form-group">
                              <label htmlFor="founder_free_days" className="text-left d-flex">Founding Partner Club Trial Days:</label>
                              <input
                                name="founder_free_days"
                                type="number"
                                id="founder_free_days"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.founder_free_days}
                                className="form-control"
                                placeholder="Enter founder free trial days"
                              />
                            </div>
                          </div>
                            <div className="row row-sm mt-3">
                            <div className="col-md-4 form-group">
                              <label htmlFor="founder_platform_fee_tier1" className="text-left d-flex">Founding Partner Platform Fee Tier 1 (1–25 Players) (GBP per club):</label>
                              <input
                                name="founder_platform_fee_tier1"
                                type="number"
                                step="any"
                                id="founder_platform_fee_tier1"
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue("platform_fee_tier1", e.target.value);
                                }}
                                onBlur={handleBlur}
                                value={values.founder_platform_fee_tier1}
                                className="form-control"
                                placeholder="Enter Tier 1 platform fee (e.g. 2.5)"
                              />
                            </div>
                            <div className="col-md-4 form-group">
                              <label htmlFor="founder_platform_fee_tier2" className="text-left d-flex">Founding Partner Platform Fee Tier 2 (26–60 Players) (GBP per club):</label>
                              <input
                                name="founder_platform_fee_tier2"
                                type="number"
                                step="any"
                                id="founder_platform_fee_tier2"
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue("platform_fee_tier2", e.target.value);
                                }}
                                onBlur={handleBlur}
                                value={values.founder_platform_fee_tier2}
                                className="form-control"
                                placeholder="Enter Tier 2 platform fee (e.g. 5)"
                              />
                            </div>
                            <div className="col-md-4 form-group">
                              <label htmlFor="founder_platform_fee_tier3" className="text-left d-flex">Founding Partner Platform Fee Tier 3 (61+ Players) (GBP per club):</label>
                              <input
                                name="founder_platform_fee_tier3"
                                type="number"
                                step="any"
                                id="founder_platform_fee_tier3"
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue("platform_fee_tier3", e.target.value);
                                }}
                                onBlur={handleBlur}
                                value={values.founder_platform_fee_tier3}
                                className="form-control"
                                placeholder="Enter Tier 3 platform fee (e.g. 9)"
                              />
                            </div>
                          </div>
                          <div className="row row-sm mt-3">
                            <div className="col-md-4 form-group">
                              <label htmlFor="standard_platform_fee_tier1" className="text-left d-flex">Standard Platform Fee Tier 1 (1–25 Players) (GBP per club):</label>
                              <input
                                name="standard_platform_fee_tier1"
                                type="number"
                                step="any"
                                id="standard_platform_fee_tier1"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.standard_platform_fee_tier1}
                                className="form-control"
                                placeholder="Enter Standard Tier 1 platform fee (e.g. 4)"
                              />
                            </div>
                            <div className="col-md-4 form-group">
                              <label htmlFor="standard_platform_fee_tier2" className="text-left d-flex">Standard Platform Fee Tier 2 (26–60 Players) (GBP per club):</label>
                              <input
                                name="standard_platform_fee_tier2"
                                type="number"
                                step="any"
                                id="standard_platform_fee_tier2"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.standard_platform_fee_tier2}
                                className="form-control"
                                placeholder="Enter Standard Tier 2 platform fee (e.g. 7.5)"
                              />
                            </div>
                            <div className="col-md-4 form-group">
                              <label htmlFor="standard_platform_fee_tier3" className="text-left d-flex">Standard Platform Fee Tier 3 (61+ Players) (GBP per club):</label>
                              <input
                                name="standard_platform_fee_tier3"
                                type="number"
                                step="any"
                                id="standard_platform_fee_tier3"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.standard_platform_fee_tier3}
                                className="form-control"
                                placeholder="Enter Standard Tier 3 platform fee (e.g. 12.5)"
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {activeTab === "app_tabs" && (
                        <>
                          <div className="row row-sm">
                            <div className="col-md-3 form-group">
                              <div className="d-flex align-items-start flex-column">
                                <label className="text-left d-flex">{t("show_faq")}</label>
                                <label className="custom-switch cp mt-2">
                                  <input className="custom-switch-input cp" name="show_faq" type="checkbox" onChange={handleChange} onBlur={handleBlur} checked={values?.show_faq === true} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-3 form-group">
                              <div className="d-flex align-items-start flex-column">
                                <label className="text-left d-flex">{t("show_privacy_policy")}</label>
                                <label className="custom-switch cp mt-2">
                                  <input className="custom-switch-input cp" name="show_privacy_policy" type="checkbox" onChange={handleChange} onBlur={handleBlur} checked={values?.show_privacy_policy === true} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-3 form-group">
                              <div className="d-flex align-items-start flex-column">
                                <label className="text-left d-flex">{t("show_terms_conditions")}</label>
                                <label className="custom-switch cp mt-2">
                                  <input className="custom-switch-input cp" name="show_terms_condition" type="checkbox" onChange={handleChange} onBlur={handleBlur} checked={values?.show_terms_condition === true} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-3 form-group">
                              <div className="d-flex align-items-start flex-column">
                                <label className="text-left d-flex">{t("show_rules_of_the_games")}</label>
                                <label className="custom-switch cp mt-2">
                                  <input className="custom-switch-input cp" name="show_rules_of_the_games" type="checkbox" onChange={handleChange} onBlur={handleBlur} checked={values?.show_rules_of_the_games === true} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-3 form-group">
                              <div className="d-flex align-items-start flex-column">
                                <label className="text-left d-flex">{t("show_safeguard_policy")}</label>
                                <label className="custom-switch cp mt-2">
                                  <input className="custom-switch-input cp" name="show_safeguard_policy" type="checkbox" onChange={handleChange} onBlur={handleBlur} checked={values?.show_safeguard_policy === true} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                        {/* {hasPermission("/admin/cms/settings/submit") ? ( */}
                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                            onClick={() => {
                              setSubmitClicked(true);
                            }}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                        </div>
                        {/* ) : null} */}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};


export default GlobalSettings;


